import { render } from "./AgentPendingDetails.vue?vue&type=template&id=908cf874"
import script from "./AgentPendingDetails.vue?vue&type=script&lang=js"
export * from "./AgentPendingDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__